import { useTranslation } from 'react-i18next';

export const useLocaleDisplayName = () => {
    const { t } = useTranslation();

    function getLocaleDisplayName(locale: string): string {
        return t(`common:localization.locales.${locale}`, locale);
    }

    return getLocaleDisplayName;
};
